export default "__VITE_ASSET__WC3$Gefm__"